// extracted by mini-css-extract-plugin
export default {"imgB":"AboutMe_imgB__741Lm","img":"AboutMe_img__x3FLM","p":"AboutMe_p__XysS6","l":"AboutMe_l__1VCaK","lc":"AboutMe_lc__SdqpB"};